/***
 *
 *   PANNEL STYLES
 *   The slide-over. Matches the frame of
 *   ui-reference/src/components/tickets/ticket-detail-panel.tsx: a right-edge
 *   surface capped at max-w-3xl with a left hairline, over a blurred scrim.
 *
 *   Replaces pannel.scss, which used a 70/80/90% width and a $c-bg background
 *   that no longer exists.
 *
 **********/

const Style = {
    overlay: 'fixed inset-0 z-[998] bg-black/30 backdrop-blur-sm',
    content: `fixed inset-y-0 right-0 z-[999] flex min-h-0 w-full max-w-3xl flex-col border-l bg-background shadow-2xl
    motion-safe:transition-transform motion-safe:duration-300 motion-safe:ease-out`,

    // CSSTransition drives these two — the reference uses a framer-motion
    // spring, which reads as an ease-out translate at this duration.
    closed: 'translate-x-full',
    open: 'translate-x-0',

    // Ticket details is a workspace, not a sheet: it needs room for a
    // conversation column plus a properties rail side by side.
    wide: 'max-w-none md:w-[94vw] lg:w-[90vw] xl:w-[84vw] xl:max-w-[1440px]',

    close: `absolute left-4 top-3 z-10 inline-flex h-8 w-8 items-center justify-center rounded-md
    text-text-secondary transition-colors hover:bg-muted hover:text-text-primary
    focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring`,
};

export default Style;
